import { c as _c } from "react/compiler-runtime";
import hasStringAfterColon from '@module/utils/hasStringAfterColon';
import IdentityVerificationButtonGroup from '@pc/components/auth/IdentityVerificationButtonGroup';
import NoticeCard from '@pc/components/card/NoticeCard';
import { useEffect } from 'react';
const notice = ['본인인증이 되어있지 않은 아이디는 아이디찾기를 통해 찾을 수 없습니다.', '고객센터로 문의주시기 바랍니다.'];
interface Props {
  onVerificationSuccess: (sessKey: string) => void;
}
function IdentityVerificationStepOnUserFind(t0) {
  const $ = _c(4);
  const {
    onVerificationSuccess
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onVerificationSuccess) {
    t1 = () => {
      const authMessage = e => {
        if (e.data.source === "@devtools-page" || e.data.source === "react-devtools-bridge" || e.data.source === "react-devtools-content-script" || e.data.source === "react-devtools-backend-manager") {
          return;
        }
        if (!e.data || typeof e?.data !== "string" || !e.data.includes("findAuth") || !hasStringAfterColon(e.data)) {
          return;
        }
        const sessKey = e.data.split(":")[1];
        onVerificationSuccess(sessKey);
      };
      window.addEventListener("message", authMessage);
      return () => {
        window.removeEventListener("message", authMessage);
      };
    };
    t2 = [onVerificationSuccess];
    $[0] = onVerificationSuccess;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><IdentityVerificationButtonGroup postMessage="findAuth" authMode="find" containerClassName="justify-center" /><NoticeCard className="mt-16" noticeList={notice} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default IdentityVerificationStepOnUserFind;